import Swiper, { Navigation, HashNavigation, Thumbs } from "swiper";
import "swiper/css";
import "swiper/css/navigation";

// var swiper = Swiper;
var init = false;

function gallerySwiper() {
  if (!init) {
    init = true;

    var galleryThumbs = new Swiper(".carousel-thumbs", {
      spaceBetween: 10,
      slidesPerView: 6,
      freeMode: true,
      // watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });

    var swiper = new Swiper(".gallery-carousel", {
      modules: [Navigation, HashNavigation, Thumbs],
      slidesPerView: 1,
      spaceBetween: 15,
      centeredSlides: true,
      a11y: true,
      hashNavigation: {
        watchState: true
      },
      navigation: {
        nextEl: ".swiper-button-next__gallery",
        prevEl: ".swiper-button-prev__gallery",
      },
      // pagination: {
      //   el: ".swiper-pagination__gallery",
      //   clickable: true,
      // },
      thumbs: {
        swiper: galleryThumbs,
      },
    });
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
gallerySwiper();
